var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "calc(1rem * 1.2500)",
    height: "calc(1rem * 0.8750)",
    viewBox: "0 0 20 14",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C7 0.448 7.448 0 8 0H19C19.552 0 20 0.448 20 1C20 1.552 19.552 2 19 2H8C7.448 2 7 1.552 7 1ZM19 6H1C0.448 6 0 6.448 0 7C0 7.552 0.448 8 1 8H19C19.552 8 20 7.552 20 7C20 6.448 19.552 6 19 6ZM12 12H1C0.448 12 0 12.448 0 13C0 13.552 0.448 14 1 14H12C12.552 14 13 13.552 13 13C13 12.448 12.552 12 12 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.3a6261908e82c32c393e6385a23491e6.svg";
export { ForwardRef as ReactComponent };